import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../styles/VideoSection.css';
import Carousel from '../components/Carousel';
function ContactENG() {




  return (
    <section className="video-section2">
      <div className="container">
    <div className="section-separator" ></div>
      {/* Support Section */}
      <div style={{
        background: 'var(--primary-black)',
        padding: '50px 40px',
        borderRadius: '20px',
        textAlign: 'center',
        border: '2px solid var(--primary-orange)',
        direction: 'ltr'
      }}>
        <h3 style={{
          fontSize: '2.3rem',
          marginBottom: '25px',
          color: 'var(--white)',
          direction: 'ltr'
        }}>
          Have you ever experienced digital violence?
        </h3>
        <p style={{
          fontSize: '1.3rem',
          lineHeight: '1.8',
          marginBottom: '30px',
          color: 'var(--text-light)',
          direction: 'ltr'
        }}>
          You are not alone.
          <br />
        You can contact the National Human Rights Council and its Regional Commissions
        </p>

        <div style={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center',
          gap: '20px',
          marginTop: '30px'
        }}>

        </div>

        <div style={{
          marginTop: '40px',
          padding: '25px',
          background: 'rgba(255, 107, 53, 0.1)',
          borderRadius: '15px',
          textAlign: 'center',
          direction: 'ltr'
        }}>
          <div style={{ marginBottom: '20px' }}>
            <div style={{ fontSize: '2.5rem', marginBottom: '12px' }}>    <img src="/images/logos/1.png" className="tab-icon4-img" /></div>
            <p style={{ fontSize: '1.2rem', color: 'var(--text-light)', lineHeight: '1.8', direction: 'ltr' }}>
              <strong style={{ color: 'var(--primary-orange)', fontSize: '1.3rem' }}>National Human Rights Council and its 12 Regional Commissions</strong>
            </p>
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
            gap: '15px',
            marginTop: '15px'
          }}>
            <div>
              <p style={{ fontSize: '1.05rem', color: 'var(--text-light)', direction: 'ltr' }}>
                <strong style={{ color: 'var(--primary-orange)' }}>Email</strong>
                <br />
                chikaya@cndh.org.ma
              </p>
            </div>
          </div>
        </div>
      </div>




            {/* Additional Platforms Section */}
            <div style={{ marginTop: '60px', direction: 'ltr' }}>
              <h3 style={{
                fontSize: '2.3rem',
                marginBottom: '35px',
                textAlign: 'center',
                color: 'var(--white)',
                direction: 'ltr'
              }}>
            You can reach out to:
              </h3>

              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
                gap: '25px'
              }}>
                {[
                  {
                    icon: '/images/logos/1.png',
                    title: 'National Human Rights Council',
                    contacts: [
                      { type: 'Email', value: 'chikaya@cndh.org.ma' },
                      { type: 'Website', value: 'www.cndh.ma' },
                      { type: 'Phone', value: '0537540000' }
                    ]
                  },
                  {
                    icon: '/images/logos/2.png',
                    title: 'Ministry of Solidarity, Social Inclusion, and Family',
                    contacts: [
                      { type: 'Website', value: 'gissr-amane.social.gov.ma' }
                    ]
                  },
                  {
                    icon: '/images/logos/3.png',
                    title: 'Public Prosecutor\'s Office',
                    contacts: [
                      { type: 'Website', value: 'plaintes.pmp.ma' }
                    ]
                  },
                  {
                    icon: '/images/logos/4.png',
                    title: 'National Platform for Digital Awareness',
                    contacts: [
                      { type: 'Website', value: 'e-himaya.gov.ma' }
                    ]
                  },
                  {
                    icon: '/images/logos/5.png',
                    title: 'Royal Gendarmerie',
                    contacts: [
                      {  value: 'Royal Gendarmerie stations' }
                    ]
                  },
                  {
                    icon: '/images/logos/6.png',
                    title: 'General Directorate of National Security',
                    contacts: [
                      { type: 'Website', value: 'e-blagh.ma' }
                    ]
                  },
                  {
                    icon: '/images/logos/7.png',
                    title: 'Dedicated platforms',
                    contacts: [
                      { type: 'Website', value: 'www.cyberconfiance.ma' },
                      { type: 'Website', value: 'evigilance.ma' },
                      { type: 'Phone', value: '06 24 40 58 89' }
                    ]
                  },
                  {
                    icon: '/images/logos/8.png',
                    title: 'Specialized civil society associations',
                    contacts: [
                      { type: '', value: 'For help and support from associations specializing in the protection of women and girls\' rights' }
                    ]
                  },
                  {
                    icon: '/images/logos/8.png',
                    title: 'Support units for women victims of violence',
                    contacts: [
                      { type: '', value: 'Courts of first instance and courts of appeal' },
                      { type: '', value: 'Public hospitals' },
                      { type: '', value: 'Police and Royal Gendarmerie' }
                    ]
                  }
                ].map((platform, index) => (
                  <div key={index} style={{
                    background: 'var(--primary-black)',
                    padding: '30px',
                    borderRadius: '15px',
                    border: '1px solid rgba(255, 107, 53, 0.3)',
                    transition: 'all 0.3s ease',

                    textAlign:'left'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-5px)';
                    e.currentTarget.style.borderColor = 'var(--primary-orange)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.borderColor = 'rgba(255, 107, 53, 0.3)';
                  }}>
                    <div style={{ fontSize: '3rem', marginBottom: '15px', textAlign: 'center' }}>
                    <img src={platform.icon} className="tab-icon4-img" />
                    </div>
                    <h4 style={{
                      fontSize: '1.3rem',
                      marginBottom: '20px',
                      color: 'var(--primary-orange)',
                      textAlign: 'center',
                      lineHeight: '1.5',
                      direction: 'ltr'
                    }}>
                      {platform.title}
                    </h4>
                    <div style={{ fontSize: '1rem', lineHeight: '2', color: 'var(--text-light)', direction: 'ltr' }}>
                      {platform.contacts.map((contact, idx) => (
                        <div key={idx} style={{ marginBottom: '10px' }}>
                          {contact.type ? (
                            <>
                              <strong>{contact.type}:</strong> {contact.value}
                            </>
                          ) : (
                            <>• {contact.value}</>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>

            </div>
    <div className="section-separator" style={{ margin: '60px 0' }}></div>
            {/* Resources Section */}
              <Link to="/en/chiffres">
            <div style={{ marginTop: '60px', direction: 'ltr' }}>
              <h3 style={{
                fontSize: '2.3rem',
                marginBottom: '35px',
                textAlign: 'center',
                color: 'var(--white)',
                direction: 'ltr'
              }}>
            Reference Documents
              </h3>

              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
                gap: '25px'
              }}>
                {[
                  {
                    icon: '⚖️',
                    title: 'Own your rights and freedoms',
                    desc: 'As guaranteed by the Moroccan Constitution and International Human Rights Law',

                  }
                ].map((resource, index) => (
                  <div key={index} style={{
                    background: 'var(--primary-black)',
                    padding: '30px',
                    borderRadius: '15px',
                    border: '1px solid rgba(255, 107, 53, 0.3)',
                    textAlign: 'center',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    direction: 'ltr'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-5px)';
                    e.currentTarget.style.borderColor = 'var(--primary-orange)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.borderColor = 'rgba(255, 107, 53, 0.3)';
                  }}>
                    <div style={{ fontSize: '3rem', marginBottom: '15px' }}>{resource.icon}</div>
                    <h4 style={{ fontSize: '1.4rem', marginBottom: '12px', color: 'var(--primary-orange)' }}>
                      {resource.title}
                    </h4>
                    <p style={{ fontSize: '1.05rem', lineHeight: '1.7', color: 'var(--text-light)' }}>
                      {resource.desc}
                    </p>
                    {resource.subtitle && (
                      <p style={{
                        fontSize: '0.95rem',
                        lineHeight: '1.6',
                        color: 'var(--text-light)',
                        marginTop: '10px',
                        fontStyle: 'italic'
                      }}>
                        {resource.subtitle}
                      </p>
                    )}
                  </div>
                ))}
              </div>
            </div>
</Link>
      </div>
    </section>
  );
}

export default ContactENG;
